// extracted by mini-css-extract-plugin
export default {"axis":"ElevationChart--axis--kmMnQ","yAxis":"ElevationChart--yAxis--ZTl9K","xAxis":"ElevationChart--xAxis--Md58V"};